/* @source catpaw @line_count 87 @branch feature/ywh-partner-ones-91169983 */
<template>
  <BikeDialog
    class="dialog-give-up-settlement"
    v-model="config.visible"
    v-bind="config"
    @onClose="onClose"
    @onConfirm="onConfirm"
  >
    <p>该操作不可逆，请确认对该账单放弃结算</p>
    <p class="italic-text">*仅限「未收到发票」的账单可以放弃结算</p>
    <mtd-form ref="form" :model="form" :rules="rules" :label-width="80">
      <mtd-form-item label="放弃原因" prop="reason">
        <mtd-textarea
          style="width: 100%;"
          v-model="form.reason"
          placeholder="输入内容不超过50个字符"
          rows="3"
        />
      </mtd-form-item>
    </mtd-form>
  </BikeDialog>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    orderNo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        reason: '',
      },
      rules: {
        reason: [{ required: true, message: '放弃原因不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onConfirm({ start, end }) {
      this.$refs.form
        .validate(valid => {
          if (!valid) return
          this.onSubmit(start, end)
        })
        .catch(() => {})
    },

    onSubmit(start, end) {
      start()
      const params = {
        orderNo: this.orderNo,
        reason: this.form.reason,
      }
      this.fetch
        .get('reconcileBill_giveUp', { params, hideGlobalMsg: true })
        .then(() => {
          this.showMessage({
            type: 'success',
            title: '提交成功',
            message: '放弃结算提交成功，请关注账单状态',
          })
          this.onClose()
        })
        .catch(err => {
          this.showMessage({
            type: 'error',
            title: '提交失败',
            message: err.message,
          })
          this.$addOwlError({
            name: `【账单列表-对账单查询-详情】放弃结算失败_${err.message}`,
            msg: { err, params },
          })
        })
        .finally(() => end())
    },

    showMessage({ type, title, message }) {
      this.$mtd
        .confirm({
          title,
          message,
          type,
          width: '430px',
          okButtonText: '我知道了',
        })
        .catch(() => {})
    },

    onClose() {
      this.$emit('close', true)
    },
  },
}
</script>
